<div class="text-center py-10">
  <h1>Tidy Ranking</h1>

  <h2>404 Not Found</h2>

  <p>
    Sorry, whatever page you're looking for does not exist.
  </p>

  <p-button routerLink="/" label="Go to homepage" type="button" severity="primary"></p-button>
</div>